import React from 'react'
import "./Our_division.css";
import {motion} from "framer-motion"
import developer from "../../assets/developer.png"
import real_estate from "../../assets/real_estate.png"
import gym from "../../assets/gym.png"
import banquet from "../../assets/banquet_hall.png"
import rennovations from "../../assets/rennovations.png"
import legal_advice from "../../assets/legal_advice.png"
import apartment_rent from "../../assets/Apartment_rentals.png"
import education from "../../assets/Education.png"




function Our_division() {
    const dhannusCategories = [
  { title: "Dhanushdhari Developers", img: developer },
  { title: "Dhanushdhari Real Estate LLP", img: real_estate },
  { title: "Dhanushdhari Burnout Gym", img: gym },
  { title: " Dhanushdhari Ganga Kinare Banquet", img: banquet },
  { title: "Dhanushdhari Renovators", img: rennovations },
  { title: "Dhanushdhari Legal Advices", img: legal_advice },
  { title: " Dhanushdhari Property Rentals", img: apartment_rent },
  { title: "Dhanushdhari Siksha", img: education },
];
const handleWebsite = (titles) => {
  if(titles==="Dhanushdhari Developers")  window.open("https://developers.houseofdhanushdhari.com/", "_blank"); 
  else if(titles===" Dhanushdhari Ganga Kinare Banquet")  window.open("https://banquet.houseofdhanushdhari.com/", "_blank");
  else if(titles==="Dhanushdhari Burnout Gym")  window.open("https://burnoutgym.houseofdhanushdhari.com/", "_blank");
  else if(titles==="Dhanushdhari Real Estate LLP")  window.open("https://realestate.houseofdhanushdhari.com/", "_blank");
  else if(titles==="Dhanushdhari Renovators")  window.open("https://renovate.houseofdhanushdhari.com/", "_blank");
  else if(titles==="Dhanushdhari Legal Advices")  window.open("https://legaladvice.houseofdhanushdhari.com/", "_blank");
  else if(titles===" Dhanushdhari Property Rentals")  window.open("https://apartment.houseofdhanushdhari.com/", "_blank");
  // else if(titles==="Dhanushdhari Siksha")  window.open("https://www.dhanushdhari.com/siksha", "_blank", "noopener,noreferrer");
  else{
return ;
  }
  
}

  return (
    <div className='Our_division'>
              <motion.h2
        className="AboutDhonustitle"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1,
          ease: "easeOut",
        }}
        viewport={{ once: true }}
      >
        Our Division
      </motion.h2>
      <motion.p
              className="AboutDhonusPara"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 1.2,
                delay: 0.3,
                ease: "easeOut",
              }}
              style={{fontSize:"1rem"}}
              viewport={{ once: true }}
            >
              Discover the diverse offering of house of Dhanushdhari, each designed to enhance your lifestyle

            </motion.p>


<div className="DhannusCategoriesPage">
  <div className="DhannusCategoriesGrid">
    {dhannusCategories.map((cat, index) => (
<motion.div
  className="DhannusCategoryCard"
  onClick={() => {
    if (cat.title !== "Dhanushdhari Siksha") {
      handleWebsite(cat.title);
    }
  }}
  key={index}
  initial={{
    opacity: 0,
    x: index < 4 ? 100 : -100,
    y: 40,
  }}
  whileInView={{
    opacity: 1,
    x: 0,
    y: 0,
  }}
  transition={{
    duration: 0.8,
    delay: index * 0.1,
    ease: "easeOut",
  }}
  whileHover={{
    scale: 1.05,
    transition: { duration: 0.3 },
  }}
  viewport={{ once: true }}
>
  <div className="DhannusCategoryImageContainer">
    <img
      src={cat.img}
      alt={cat.title}
      className={`DhannusCategoryImage ${
        cat.title === "Dhanushdhari Siksha" ? "blurImage" : ""
      }`}
    />

    {cat.title === "Dhanushdhari Siksha" && (
      <div className="comingSoonOverlay">
        Coming Soon
      </div>
    )}
  </div>

  <h5 className="DhannusCategoryTitle" style={{ padding: "5px" }}>
    {cat.title}
  </h5>
</motion.div>
    ))}
  </div>

  <motion.hr
    style={{
      backgroundColor: "black",
      height: "2px",
      border: "none",
      marginTop: "20px",
    }}
    initial={{ width: 0, opacity: 0 }}
    whileInView={{ width: "80%", opacity: 1 }}
    transition={{ duration: 1.2, delay: 0.5, ease: "easeOut" }}
    viewport={{ once: true }}
  />
</div>

    </div>
  )
}

export default Our_division